module.exports = __webpack_public_path__ + "static/img/on3.d23026a4.png";